// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/schenkelfedern-zum-oeffnen-einer-klappe-bei-geschirrspuelmaschinen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSchenkelfedernZumOeffnenEinerKlappeBeiGeschirrspuelmaschinenDE: PageEntry = {
  id: "example.produkte-schenkelfedern-zum-oeffnen-einer-klappe-bei-geschirrspuelmaschinen",
  locale: "de",
  slug: "produkte/schenkelfedern-zum-oeffnen-einer-klappe-bei-geschirrspuelmaschinen",
  seo: {
    title: "Schenkelfedern zum Öffnen einer Klappe bei Geschirrspülmaschinen | Dietz GmbH",
    description: "Sonderwerkzeuge für spezielle Biegeabläufe",
  },
  type: "post",
  h1: "Schenkelfedern zum Öffnen einer Klappe bei Geschirrspülmaschinen",
  intro: "Sonderwerkzeuge für spezielle Biegeabläufe",
  blocks: [
    { kind: "image", src: "/images/live/dtz-schenkelfeder-geschirrsp.jpg", alt: "Schenkelfedern zum Öffnen einer Klappe bei Geschirrspülmaschinen", width: 1400, height: 1120 }
  ],
};
